<template>
	<div class="diyGoods-ui">
		<div class="item2" @click="goPage(datas.link)" v-if="datas.style=='2'">
			<img :src="datas.backgroundImg">
			<div class="item-info">
				<div class="item-info-lf">
					<div class="name" :style="textStyle">{{datas.goodsName}}</div>
					<div class="subtitle" :style="subTitleStyle" v-if="datas.subTitle">{{datas.subTitle}}</div>
				</div>
				<div class="item-info-rt" v-if="datas.lowPrice!==''">
					<div class="price" :style="priceStyle" >
						￥{{datas.lowPrice}}<b>起</b>
						
					</div>
				</div>
				
			</div>
		</div>
		<div class="item" @click="goPage(datas.link)" v-else>
			<img :src="datas.backgroundImg" >
			<div class="item-info" :style="textStyle">
				<div class="item-info-lf">
					<div class="name" :style="textStyle">{{datas.goodsName}}</div>
					<div class="labels">
						<div class="label" v-for="(item,index) in datas.tags" :key="index">
							{{item}}
						</div>
					</div>
				</div>
				<div class="item-info-rt">
					<div class="price" :style="textStyle">
						<b v-if="datas.lowPrice!==''">￥{{datas.lowPrice}}起</b>
					</div>
					<div class="btn" :style="btnStyle">
						{{datas.btText}}
					</div>
				</div>
			</div>
		</div>
	</div>


</template>

<script>
	// 标题

	export default {

		props: {
			datas: Object
		},
		methods: {
			goPage(link){
				window.location.href = link
			}
		},
		computed: {
			priceStyle(){
				return `color:${this.datas.priceColor};`;
			},
			subTitleStyle(){
				
				return `color:${this.datas.subTitleColor};`;
			},
			textStyle() {
				return `color:${this.datas.textColor};`;
			},
			btnStyle() {
				return `background:${this.datas.btColor};color:${this.datas.btTextColor};`;
			}
		}
	};
</script>

<style lang="less" scoped>
	.diyGoods-ui {
		padding: 0.3999rem 0.3999rem 0;

		.item {
			border-radius: 0.31992rem;
			overflow: hidden;
			
			position: relative;
			
			img{
				
				width: 100%;
				display: block;
			}
			.item-info {
				color: #fff;
				left: 0;
				right: 0;
				position: absolute;
				bottom: 0;
				padding: 0.6665rem 0.3999rem 0.2666rem;
				display: flex;
				justify-content: space-between;

				.item-info-lf {
					flex: 1;

					.name {
						font-family: "Alibaba_PuHuiTi_Heavy";
						font-size: 20px;

						font-weight: bold;

					}

					.labels {
						margin-top: 0.02666rem;

						.label {
							display: inline-block;
							font-size: 10px;
							margin-top: 0.1333rem;
							padding: 0.05332rem 0.1333rem;
							margin-right: 0.1333rem;
							border-radius: 0.21328rem;
							background: rgba(255, 255, 255, 0.30);
						}
					}
				}

				.item-info-rt {
					
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-end;
					.price {
						height: 0.5332rem;
						font-size: 14px;
						font-family: PingFangSC-Semibold;
						font-weight: bold;
					}

					.btn {
						margin-top: 0.18662rem;
						margin-bottom: 0.2666rem;
						display: flex;
						justify-content: center;
						align-items: center;
						font-family: PingFangSC-Semibold;
						font-size: 15px;
						color: #01B763;
						font-weight: bold;
						height: 0.6665rem;
						background: #fff;
						border-radius: 0.34658rem;
						padding: 0 0.23994rem;

					}
				}
			}
		}
		.item2 {
			border-radius: 0.31992rem;
			overflow: hidden;
			box-shadow: 0px 5px 20px -5px rgba(0, 0, 0, 0.15);
			position: relative;
			
			img{
				
				width: 100%;
				display: block;
			}
			.item-info {
				color: #fff;
				padding: 0.1333rem 0.3999rem 0.34658rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
		
				.item-info-lf {
					flex: 1;
					line-height: 1.4;
					.name {
						font-family: "Alibaba_PuHuiTi_Heavy";
						font-size: 20px;
						color: #333333;
		
					}
					.subtitle{
						margin-top: 0.07998rem;
						font-size: 12px;
						color: #999999;
					}
		
					
				}
		
				.item-info-rt {
					
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-end;
					.price {
						align-items: center;
						display: flex;
						font-family: "Alibaba_PuHuiTi_Heavy";
						font-size: 19px;
						b{
							font-family: AlibabaPuHuiTiM;
							font-size: 12px;
							margin-left: 0.05332rem;
			
						}
					}
		
					
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/diyGoods.vue